import { render } from "./CenteredHero.vue?vue&type=template&id=11385af6"
import script from "./CenteredHero.vue?vue&type=script&lang=js"
export * from "./CenteredHero.vue?vue&type=script&lang=js"

import "./CenteredHero.vue?vue&type=style&index=0&id=11385af6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__